<template>
  <div class="page-con">
    <div class="page-con-header clearfix" style="display: flex;">
      <Button type="primary" icon="ios-add" v-if="isHavePermission('bankAccount:createPlatformCompany:add')"
              @click="showDialog">创建银行账户
      </Button>
      <Button icon="md-download" @click="download" style="margin-left: 20px"
              v-if="isHavePermission('bankAccount:export')">导出
      </Button>
      <vxe-button icon="vxe-icon--refresh" @click="refresh"
                  :style="!isHavePermission('bankAccount:createPlatformCompany:add')?'' :'margin-left: 20px'">刷新
      </vxe-button>
      <div style="margin-left: auto;">
        <vxe-input v-model="accountName" type="search" placeholder="账户名称" @search-click="search"
                   @keyup.enter.native="search"></vxe-input>
        <vxe-input v-model="accountNum" style="margin-left: 10px" type="search" placeholder="银行账号"
                   @search-click="search"
                   @keyup.enter.native="search"></vxe-input>
        <Button status="primary" icon="ios-search" @click="search" style="margin-left: 10px;border-radius: 5px">
          搜索
        </Button>
        <vxe-button icon="vxe-icon--refresh" @click="reset" style="margin-left: 10px">重置</vxe-button>
        <vxe-button icon="vxe-icon--refresh" @click="refresh" style="margin-left: 10px">刷新</vxe-button>
      </div>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table class="table-style"
                 highlight-hover-row
                 show-footer
                 stripe
                 align="center"
                 border="none"
                 :data="tableData"
                 :loading="loading"
                 @filter-change="filterChangeMethod">
        <vxe-table-column field="id" title="序号" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
            <Dropdown
                v-if="isHavePermission('bankAccount:createPlatformCompany:update') || isHavePermission('bankAccount:createPlatformCompany:delete')"
                trigger="click" style="margin-left: 20px;" transfer>
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left:70px;">
                <div style="display: flex;flex-direction: column;">
                  <Button class="button-gengduo" v-if="isHavePermission('bankAccount:createPlatformCompany:update')"
                          @click="openUpdateView(row)">编辑
                  </Button>
                  <Button class="button-gengduo" v-if="row.isDefault === 1" disabled>默认
                  </Button>
                  <Button class="button-gengduo"
                          v-if="isHavePermission('bankAccount:createPlatformCompany:default') && row.isDefault !== 1"
                          style="color: blue" @click="setDefault(row)">设为默认
                  </Button>
                  <Button class="button-gengduo" style="color: #ed4014;"
                          v-if="isHavePermission('bankAccount:createPlatformCompany:delete')"
                          @click="commitDelete(row)">删除
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <!--        <vxe-table-column field="companyName" title="所属公司" show-overflow width="150"></vxe-table-column>-->
        <vxe-table-column field="accountName" title="账户名称" min-width="300"></vxe-table-column>
        <vxe-table-column field="bankName" title="开户行" min-width="400"></vxe-table-column>
        <vxe-table-column field="openOrgNum" title="联行号" min-width="150"></vxe-table-column>
        <vxe-table-column field="accountNum" title="银行账号" min-width="300"></vxe-table-column>
        <vxe-table-column field="bankAccountType" title="账户类型" :filters="accountTypeList"
                          :filter-multiple="false" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.bankAccountType | bankAccountType }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isDefault" title="默认" :filters="[{label: '否', value: 0}, {label: '是', value: 1}]"
                          :filter-multiple="false" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.isDefault === 1 ? '是' : '否' }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="updateUser" title="操作人" width="100"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" width="110">
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="visible" :title="title" width="1300" height="600" @close="closeCreate" resize remember
               position="center">
      <create-bank-account-modal ref="accountModal" @afterSave="afterSave" @close="close"></create-bank-account-modal>
    </vxe-modal>
  </div>
</template>

<script>
import CreateBankAccountModal from "./CreateBankAccountModal";
import $api from "@/apiProvider";
import getAuthOrization from "@/mixin/getAuthOrization";
import {assign, getBlob, hideLoading, isEmpty, postBlob, saveBlob, showLoading} from "@/utils/util";

export default {
  name: "BankAccount",
  components: {CreateBankAccountModal},
  mixins: [getAuthOrization],
  data() {
    return {
      title: '',
      visible: false,
      updateVisible: false,
      loading: false,
      tableData: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100
      },
      accountName: null,
      accountNum: null,
      bankAccountType: null,
      isDefault: null,
      accountTypeList: [{
        label: '现金账户',
        value: 1
      }, {
        label: '银行账户（一般户）',
        value: 2
      }, {
        label: '银行账户（基本户）',
        value: 3
      }],
    };
  },
  filters: {
    bankAccountType(val) {
      if (val != null) {
        if (val === 1) {
          return "现金账户"
        }
        if (val === 2) {
          return "银行账户（一般户）"
        }
        if (val === 3) {
          return "银行账户（基本户）"
        }
        if (val === 4) {
          return "汇票账户"
        }
      }
    }
  },
  mounted() {
    this.$bus.$on("公司银行账户", () => {
      this.accountName = null;
      this.accountNum = null;
      this.getPlatformCompanyList();
    });
    this.getPlatformCompanyList();
  },
  methods: {
    async download() {
      showLoading()
      let res = postBlob("/api/order/platform_corp/platformCompanyListExport", {
        orderBy: 2,
        isDesc: 1,
        accountName: this.accountName,
        accountNum: this.accountNum,
        bankAccountType: this.bankAccountType,
        isDefault: this.isDefault,
        page: this.page.currentPage,
        rows: this.page.pageSize,
      });
      hideLoading()
      let fileName = "导出公司银行账户列表.xls";
      await saveBlob(fileName, res.data)
    },
    filterChangeMethod({column, property, values, datas, filters, $event}) {
      this.page.currentPage = 1;
      if (property === "bankAccountType") {
        if (values.length > 0) {
          this.bankAccountType = values[0];
        } else {
          this.bankAccountType = null;
        }
      }
      if (property === "isDefault") {
        if (values.length > 0) {
          this.isDefault = values[0];
        } else {
          this.isDefault = null;
        }
      }
      this.getPlatformCompanyList()
    },
    reset() {
      this.accountName = null;
      this.accountNum = null;
    },
    search() {
      this.page.currentPage = 1;
      this.getPlatformCompanyList();
    },
    async setDefault(row) {
      row.isDefault = 1;
      let res = await $api.platformCorp.post("createPlatformCompany", {
        data: [row]
      });
      if (res.status === 1) {
        this.$Message.success('设置成功');
        this.getPlatformCompanyList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    refresh() {
      this.getPlatformCompanyList();
    },
    afterSave() {
      this.visible = false;
      this.getPlatformCompanyList();
    },
    async getPlatformCompanyList() {
      this.loading = true;
      // let data = this.listQuery;
      let res = await $api.platformCorp.post("getPlatformCompanyList", {
        orderBy: 2,
        isDesc: 1,
        accountName: this.accountName,
        accountNum: this.accountNum,
        bankAccountType: this.bankAccountType,
        isDefault: this.isDefault,
        page: this.page.currentPage,
        rows: this.page.pageSize,
      });
      this.loading = false;
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.tableData = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    commitDelete(row) {
      this.$XModal.confirm('您确定要删除吗？').then(type => {
        if (type === 'confirm') {
          this.deleteAccount(row);
        }
      })
    },
    async deleteAccount(row) {
      row.isDelete = 1;
      let res = await $api.platformCorp.post("createPlatformCompany", {
        data: [row]
      });
      if (res.status === 1) {
        this.$Message.success('删除成功');
        this.getPlatformCompanyList();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    close() {
      this.visible = false;
    },
    closeCreate() {
      this.visible = false;
      this.$refs.accountModal.close();
    },
    changePage(e) {
      this.page.currentPage = e.currentPage;
      this.page.pageSize = e.pageSize;
      this.getPlatformCompanyList();
    },
    showDialog() {
      this.title = '创建银行账户';
      this.visible = true;
    },
    openUpdateView(row) {
      this.title = '修改银行账户';
      this.visible = true;
      this.$refs.accountModal.setData(row);
    }
  }
};
</script>

<style>
@import "../../../src/assets/icon/icon-filter/iconfont.css";
@import "../../../src/assets/icon/icon-more/iconfont.css";

.button-gengduo {
  border: none;
}

.button-gengduo:focus {
  outline: none;
  border-color: transparent;
  box-shadow: none;
}

.page-con-header {
  margin-bottom: 10px;
  position: relative;
}
</style>
